import { useEnvContext, useWebStoreContext } from "contexts";
import { FeaturesFlags } from "helpers";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLinks } from "./useLinks";
import { usePopupsState } from "./usePopupsState";

export const useRedirectFTUE = (): void => {
	const links = useLinks();
	const navigate = useNavigate();
	const location = useLocation();
	const { isFeatureFlagEnabled, isFeatureFlagsReady } = useEnvContext();
	const { authToken, userTracker, activeItemToBeClicked } =
		useWebStoreContext();
	const areFeatureFlagsReady = isFeatureFlagsReady(authToken?.value);
	const {
		isAnyPopupOpen,
		isWelcomeFlowActive,
		IsInAppToWebDipChecking,
		IsFriendReferralAcceptInviteChecking
	} = usePopupsState();
	const isFtueV2Enabled = isFeatureFlagEnabled(FeaturesFlags.FTUE_V2);
	const isShopFtueEnabled =
		isFtueV2Enabled || isFeatureFlagEnabled(FeaturesFlags.UI_V2);
	const allowLoyaltyBeforeShopFtue =
		isFtueV2Enabled && location.pathname === links.loyalty.path;

	useEffect(() => {
		if (
			authToken?.value &&
			areFeatureFlagsReady &&
			!!userTracker?.metadata &&
			!isAnyPopupOpen &&
			!IsInAppToWebDipChecking &&
			!IsFriendReferralAcceptInviteChecking &&
			!isWelcomeFlowActive &&
			!activeItemToBeClicked
		) {
			if (
				userTracker?.metadata?.hasSeenTutorial !== "true" &&
				isShopFtueEnabled &&
				!allowLoyaltyBeforeShopFtue
			) {
				navigate(links.shop.path);
			} else if (
				userTracker?.metadata?.hasSeenLPTutorial !== "true" &&
				isFeatureFlagEnabled(FeaturesFlags.LOYALTY_SHOP_FTUE) &&
				!isFeatureFlagEnabled(FeaturesFlags.FTUE_V2)
			) {
				navigate(links.loyalty.path);
			}
		}
	}, [
		areFeatureFlagsReady,
		isAnyPopupOpen,
		links.shop.path,
		authToken?.value,
		isShopFtueEnabled,
		isWelcomeFlowActive,
		activeItemToBeClicked,
		IsInAppToWebDipChecking,
		!!userTracker?.metadata,
		allowLoyaltyBeforeShopFtue,
		IsFriendReferralAcceptInviteChecking,
		userTracker?.metadata?.hasSeenTutorial,
		userTracker?.metadata?.hasSeenLPTutorial
	]);
};
